import Button from '@jetbrains/ring-ui/components/button/button'
import type {CustomAnchorProps, SelectItem} from '@jetbrains/ring-ui/components/select/select'
import Select from '@jetbrains/ring-ui/components/select/select'
import {memo, useCallback} from 'react'
import {useLocation} from 'react-router-dom'

import type {QueryParams} from '../../../../../../utils/queryParams'
import {getFilterQueryParams} from '../../BuildTestsTab.utils'

import {ViewType} from './TestsViewSelect.utils'

import styles from './TestsViewSelect.css'

type Props = {
  className?: string
  onChangeQueryParams: (arg0: QueryParams) => unknown
}
const itemsHash = {
  [ViewType.SUITES]: {
    key: ViewType.SUITES,
    label: 'Suites',
    title: '',
  },
  [ViewType.PACKAGES]: {
    key: ViewType.PACKAGES,
    label: 'Packages/namespaces',
    title: '',
  },
  [ViewType.CLASSES]: {
    key: ViewType.CLASSES,
    label: 'Classes',
    title: '',
  },
  [ViewType.TESTS]: {
    key: ViewType.TESTS,
    label: 'Tests',
    title: '',
  },
}
const itemsData = [
  itemsHash[ViewType.SUITES],
  itemsHash[ViewType.PACKAGES],
  itemsHash[ViewType.CLASSES],
  itemsHash[ViewType.TESTS],
]

function TestsViewSelect({className, onChangeQueryParams}: Props) {
  const location = useLocation()
  const {view} = getFilterQueryParams(location)
  const selectedItem: SelectItem<{key: string}> = itemsHash[view] ?? itemsHash[ViewType.TESTS]
  const onChange = useCallback(
    (value: SelectItem<{key: string}> | null) =>
      onChangeQueryParams({
        view: value?.key,
        orderBy: null,
        order: null,
      }),
    [onChangeQueryParams],
  )
  const renderCustomAnchor = useCallback(
    ({wrapperProps, buttonProps, popup}: CustomAnchorProps) => (
      <span {...wrapperProps}>
        <Button {...buttonProps} dropdown>
          <span>{'View '}</span>
          <span className={styles.anchorName}>{selectedItem.label}</span>
        </Button>
        {popup}
      </span>
    ),
    [selectedItem],
  )
  return (
    <div className={className}>
      <Select
        type={Select.Type.CUSTOM}
        data={itemsData}
        selected={selectedItem}
        customAnchor={renderCustomAnchor}
        onChange={onChange}
      />
    </div>
  )
}

export default memo<Props>(TestsViewSelect)
